import styles from "./Choice.module.css";

const Choice = ({
  choice,
  percent,
  clicked=false,
  onClick
}) => {
  const correct = choice['correct']
  const width = (120 + (percent || 0)) + 'px'


  if (clicked) {
    return (
      <div  className={styles.numberQuestion} >
        <div style={{ minWidth: width }} className={`${styles.animation} ${ styles.choiceWraper } ${ correct ? styles.correctBg : styles.wrongBg }`}>
          <div className={ `${styles.number} ${ correct ? styles.correct : styles.wrong }` }>
            {choice['number']}
          </div>

          <div
            
            className={ `${styles.content}  `}>
            { `${choice['answer']}`}
          </div>
        </div>
        <span className={`${ correct ? styles.correctPercent : styles.wrongPercent }`}> {percent || 0}% </span>
      </div>
        
    );
  }

  return (
    <div className={styles.choiceWraper} onClick={() => onClick(choice['number']) } >
      <div className={`${styles.number} ${styles.defaultColor}`}> {choice['number']}</div>
      <div className={styles.content}> {choice['answer']}</div>
    </div>
  );
};

export default Choice;
